module.exports = __webpack_public_path__ + "static/img/lp1.fff924c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/brightscreentime/brightscreentime/lp1.png
// module id = 7jEP
// module chunks = 0